<div class="row flex-auto bottombar-influencer-fragement" (clickOutside)="onClickOutSideBottomBar($event)">
  <div class="col-md-12 col-sm-12"
       *ngIf="shouldShowInfluencerActionButton() || shouldShowActionButtons()">
    <div class="row flex-auto">
      <div class="col-md-12 col-sm-12 d-flex bottombar-tabs">
        <achoo-tabs [(selectedTabKey)]="tabKey" (tabClicked)="replaceTabState($event)" #mainTabs>
          <achoo-tab [tabKey]="'influencers'">
            <ng-template tabHeading>
              <a>
                <div class="d-flex flex-auto justify-content-start">
                  <achoo-checkbox *ngIf="!showPreviewSelectedInfluencerFragment" [(model)]="hasSelectedProfiles"
                                  id="'select_all_preview_influencer_chx'"
                                  label="{{selectedProfileLabel}}">
                  </achoo-checkbox>
                  <achoo-checkbox *ngIf="showPreviewSelectedInfluencerFragment" [(model)]="hasSelectedProfiles"
                                  id="'select_all_preview_influencer_2_chx'"
                                  label="{{selectedProfileLabel}}">
                  </achoo-checkbox>
                </div>
              </a>
            </ng-template>
            <div class="tab-content">
              <div class="bottombar-content full-content">
                <div class="preview-influencer-container" [ngClass]="{'discover-review': discoverInfluencer}" *ngIf="showPreviewSelectedInfluencerFragment">
                  <preview-selected-influencers [activateBottomBar]="true"
                                                [listInfluencers]="selectedInfluencers"
                                                [platformList]="platformList">
                  </preview-selected-influencers>
                </div>
              </div>
            </div>
            </achoo-tab>
            <achoo-tab *ngIf="discoverInfluencer" [tabKey]="'posts'">
              <ng-template tabHeading>
                <a>
                  <div class="d-flex flex-auto justify-content-start">
                    <achoo-checkbox *ngIf="!showPreviewSelectedInfluencerFragment" [(model)]="hasSelectedPost"
                                    id="'select_all_preview_post_chx'"
                                    label="{{'discover.nav-tabs.selected_post' | translate:{selected_number: countNumberSelectedPost()} }}">
                    </achoo-checkbox>
                    <achoo-checkbox *ngIf="showPreviewSelectedInfluencerFragment" [(model)]="hasSelectedPost"
                                    id="'select_all_preview_post_2_chx'"
                                    label="{{'discover.nav-tabs.selected_post' | translate:{selected_number: countNumberReviewedPost} }}">
                    </achoo-checkbox>
                  </div>
                </a>
              </ng-template>
              <div class="tab-content">
                <div class="bottombar-content full-content">
                  <div class="preview-influencer-container post-list-review" *ngIf="showPreviewSelectedInfluencerFragment">
                    <preview-selected-influencers
                      [activateBottomBar]="true"
                      [listInfluencers]="selectedPosts"
                      [platformList]="platformList"
                      [displayInfo]="'posts'">
                    </preview-selected-influencers>
                  </div>
                </div>
              </div>
            </achoo-tab>
        </achoo-tabs>
      </div>
      <div class="col-md-6 col-sm-6 buttons-manage align-items-end" *ngIf="!showPreviewSelectedInfluencerFragment && !discoverInfluencer">
        <div class="buttons d-flex flex-auto justify-content-end">
          <button class="button sm-button gray" (click)="clearInfluencerSelection()">{{'group_details.action_bar.clear' | translate}}</button>
          <button *ngIf="!isRecentlyVisitedInfluencerGroup"
                  class="button sm-button ml-10px red"
                  [attr.disabled]="shouldDisableActionButtonGroup() || isArchivedCampaign ? true : null"
                  actionByLevels="{{actionByLevel}}"
                  [wallName]="wallName"
                  (afterChecking)="showWarningDeleteMultipleInfluencerPopup()">
            {{'common.btn.delete' | translate}}
          </button>
          <button class="button sm-button ml-10px green" [attr.disabled]="shouldDisableActionButtonGroup() ? true : null" (click)="previewSelectedInfluencersToCampaign()">
            {{'common.btn.review' | translate}}
          </button>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 buttons-manage align-items-end" *ngIf="showPreviewSelectedInfluencerFragment">
        <div class="buttons d-flex flex-auto justify-content-end" *ngIf="!discoverInfluencer && !campaignInfluencerList">
          <button class="button sm-button gray" (click)="clearPreviewedInfluencer()">{{'common.btn.close' | translate}}</button>
          <button class="button sm-button ml-10px red" (click)="showWarningClearSelectedInfluencerPopup()">{{'common.btn.clear' | translate}}</button>
          <button class="button sm-button ml-10px green"
                  [attr.disabled]="shouldDisableActionButtonGroup() ? true : null"
                  actionByLevels="Add to Campaign"
                  [wallName]="'Campaigns Disabled'"
                  [actionData]="actionData('campaign')"
                  (afterChecking)="addSelectedInfluencersToCampaign()">
            {{'common.btn.add_to_compaign' | translate}}
          </button>
          <button class="button sm-button ml-10px blue"
                  [attr.disabled]="shouldDisableActionButtonGroup() ? true : null"
                  actionByLevels="Add to Group"
                  [wallName]="'Groups Disabled'"
                  [actionData]="actionData('group')"
                  (afterChecking)="addSelectedInfluencersToGroup()">
            {{'common.btn.add_to_group' | translate}}
          </button>
        </div>
        <div class="buttons d-flex flex-auto justify-content-end" *ngIf="discoverInfluencer || campaignInfluencerList">
          <button class="button sm-button gray" (click)="clearPreviewedInfluencer()">{{'common.btn.close' | translate}}</button>
          <button class="button sm-button ml-10px red" (click)="showWarningClearSelectedInfluencerPopup()">{{'common.btn.clear' | translate}}</button>
          <button class="button sm-button ml-10px blue"
                  [attr.disabled]="shouldDisableActionButtonGroup() ? true : null"
                  actionByLevels="Add to campaign"
                  [wallName]="'Campaigns Disabled'"
                  [actionData]="actionData('campaign')"
                  (afterChecking)="addSelectedInfluencersToCampaign()">
            {{'common.btn.add_to_compaign' | translate}}
          </button>
          <button class="button sm-button ml-10px green"
                  *ngIf="tabKey === 'influencers'"
                  [attr.disabled]="shouldDisableActionButtonGroup() ? true : null"
                  actionByLevels="Add to group"
                  [wallName]="'Groups Disabled'"
                  [actionData]="actionData('group')"
                  (afterChecking)="addSelectedInfluencersToGroup()">
            {{'common.btn.add_to_group' | translate}}
          </button>
          <button class="button add-post-project-btn ml-10px green"
                  *ngIf="tabKey === 'posts'"
                  [attr.disabled]="shouldDisableActionButtonGroup() ? true : null"
                  actionByLevels="Add to group"
                  [wallName]="'Projects Disabled'"
                  [actionData]="actionData('project')"
                  (afterChecking)="addSelectedPostsToProject()">
            {{'common.btn.add_to_project' | translate}}
          </button>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 buttons-manage align-items-end" *ngIf="discoverInfluencer && !showPreviewSelectedInfluencerFragment">
        <div class="buttons d-flex flex-auto justify-content-end">
          <button class="button sm-button red" (click)="onClearDiscoverResultAndFilter()">
            {{'common.btn.clear' | translate}}
          </button>
          <button class="button sm-button green" (click)="reviewInfluencers()">
            {{'common.btn.review' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="row action-fragment-container">
      <div class="col-md-12 col-sm-12" *ngIf="(shouldShowGroupActionButton() && !discoverInfluencer && !isRecentlyVisitedInfluencerGroup) || temporaryHiddenAddInfluencerToGroup">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="buttons d-flex flex-auto justify-content-end">
              <button *ngIf="isUsingForGroupDetail"
                      class="button sm-button green"
                      actionByLevels="Auto update groups"
                      [wallName]="'Advanced Groups'"
                      [actionData]="groupSettingActionData()"
                      (afterChecking)="showGroupSettings()">
                {{'group_details.action_bar.group_settings' | translate}}
              </button>
              <button class="button sm-button blue"
                      actionByLevels="{{getActionLevelForAddingInfluencer()}}"
                      [wallName]="getWallNameForAddingInfluencer()"
                      [actionData]="actionDataForAddingInfluencer()"
                      (afterChecking)="showAddInfluencerFragment()"
                      [disabled]="isArchivedCampaign">
                {{'group_details.action_bar.add_influencer' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 d-flex" *ngIf="showAddInfluencerToGroupFragment" [ngClass]="{'temp-hidden-add-influencer-group': temporaryHiddenAddInfluencerToGroup}">
        <add-influencer-group #AddInfluencerToGroupFragment class="add-influencer-group flex-auto"
                              [influencerGroup]="influencerGroup"
                              [showAddInfluencerToGroupFragment]="showAddInfluencerToGroupFragment"
                              [alreadySelectedInfluencers]="selectedInfluencerToAddGroup"
                              [pendingAddInfluencerToGroup]="addInfluencerGroup"
                              (addInfluencerToGroupEvent)="addMoreInfluencerToCurrentGroup($event)"
                              (addNewInfluencerManuallyEvent)="showFragmentAddInfluencerManually($event)"
                              (closeFragmentEvent)="closeAddInfluencerFragment($event)">
        </add-influencer-group>
      </div>
      <div class="col-md-12 col-sm-12 d-flex" *ngIf="showAddInfluencerToCampaigns">
        <add-influencer-campaign #AddInfluencerCampaign class="d-flex flex-auto"
                                [platformList]="platformList"
                                [countryList]="countryList"
                                [isAddImmediately]="false"
                                [campaign]="getCampaign()"
                                [isShowAddInfluencerToCampaignsFragment]="showAddInfluencerToCampaigns"
                                [alreadySelectedInfluencers]="selectedInfluencerToAddCampaign"
                                [addInfluencerAsAccepted]="addInfluencerToCampaignAsAccepted"
                                [initializeInfluencerList]="pendingInfluencerListAddToCampaign"
                                (closeFragmentEvent)="closeAddInfluencerToCampaign($event)"
                                (addNewInfluencerManuallyEvent)="showFragmentAddInfluencerManually($event)"
                                (eventAddInfluencerToCampaigns)="addMoreInfluencerToCampaign($event)">>
        </add-influencer-campaign>
      </div>
      <div class="col-md-12 col-sm-12" *ngIf="showAddInfluencerToCampaignFragment && tabKey === 'influencers'">
        <add-influencers-to-campaign #AddInfluencerToCampaignFragment (addToCampaignExecution)="addInfluencerToCampaign($event)"
                                     (backToPreviewInfluencerEvent)="hideAddToCampaignFragment(true)"
                                     [selectedCampaign]="selectedCampaign"
                                     [isUsedToAddPost]="false"
                                     [campaignList]="campaignList">
        </add-influencers-to-campaign>
      </div>
      <div class="col-md-12 col-sm-12" *ngIf="showAddInfluencerToCampaignFragment && tabKey === 'posts'">
        <add-influencers-to-campaign (addToCampaignExecution)="addPostsToCampaign($event)"
                                     (backToPreviewInfluencerEvent)="hideAddToCampaignFragment(true)"
                                     [totalSelectedPost]="numberPreviewedPost"
                                     [selectedCampaign]="selectedCampaign"
                                     [campaignList]="campaignListToPost">
        </add-influencers-to-campaign>
      </div>
      <div class="col-md-12 col-sm-12" *ngIf="showAddInfluencersToAnotherGroupFragment">
        <add-influencer-to-group #AddInfluencerToOtherGroupFragment
                                    (addInfluencerToGroupExecution)="executeAddingInfluencerToGroup($event)"
                                    (backToPreviewInfluencerEvent)="hideMoveInfluencerFragment(true)"
                                    (createNewGroupEvent)="openCreateNewGroupFragment($event)"
                                    [influencerGroupList]="influencerGroupList"
                                    [pendingAddInfluencerGroup]="addInfluencerGroup">
        </add-influencer-to-group>
      </div>
      <div class="col-md-12 create-group-fragment" *ngIf="showCreateNewGroupFragment" [ngClass]="{'temp-hidden': temporaryHidden}">
        <create-group-fragment [isShowCreateGroupForm]="showCreateNewGroupFragment"
                               [groupNeedToUpdate]="influencerGroup"
                               [activePage]="activePage"
                               (beforeCreateOrUpdateGroupEvent)="beforeCreateOrUpdateGroup($event)"
                               (afterCreateOrUpdateGroupEvent)="afterCreateOrUpdateGroup($event)"
                               (cancelCreateOrUpdateGroupEvent)="closeCreateGroupFragment()">
        </create-group-fragment>
      </div>
      <div class="col-md-12 col-sm-12" *ngIf="showAddPostToProjectFragment">
        <add-posts-to-project  #AddPostsToProject
                               (addPostsToProjectExecution)="addMultiplePostIntoProject($event)"
                               (backToPreviewInfluencerEvent)="hideAddPostToProjectFragment()"
                               (createNewProjectEvent)="showCreateProjectFragement(null, true)"
                               [isShowSummarize]="true"
                               [numberSelectedPost]="countNumberReviewedPost"
                               [activePage]="activePage"
                               [projectList]="projectList" >
        </add-posts-to-project>
      </div>
      <div class="col-md-12 create-group-fragment" *ngIf="showCreateNewProjectFragment">
        <edit-project [project]="newProject"
                      [activePage]="activePage"
                      [countryList]="countryList"
                      [showCountryList]="showCountryList"
                      (closeBottomBarCallback)="closeEditProjectFragment($event)"
                      (beforeCreateOrUpdateProject)="beforeCreateOrUpdateProject()">
        </edit-project>
      </div>
      <div class="col-md-12 add-influencer-manually-fragment" *ngIf="showAddInfluencerManuallyFragment">
        <add-influencer-manually [influencerGroup]="influencerGroup"
                                 [influencerSuggestion]="processingInfluencerSuggestion"
                                 (closeFragmentAddInfluencerManually)="closeFragmentAddInfluencerManually($event)">
        </add-influencer-manually>
      </div>
    </div>
  </div>
</div>

<achoo-popup #AlertAddInfluencerToCampaignSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{campaignNotificationMsg}}</span>
</achoo-popup>
<achoo-popup #AlertAddInfluencerToGroupSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{msgAddInfluencerToGroupSuccess}}</span>
  </div>
</achoo-popup>
<achoo-popup #AlertAPIError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{serverErrorMessage}}</span>
  </div>
</achoo-popup>

<achoo-popup #WarningDeleteInfluencerDialog
             cancelBtnLabel="{{'common.btn.delete_confirm_cancel' | translate:{container : deleteInfluencerContext} }}"
             acceptBtnLabel="{{'common.btn.delete_confirm_ok' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="deleteSelectedInfluencers()"
             (cancelCallback)="closeWarningDeleteInfluencerPopup()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'group_details.influencer.delete_warning_message' | translate:
      {numOfInfluencer: numOfInfluencerToDelete} }}</span>
  </div>
</achoo-popup>

<achoo-popup #WarningClearSelectedInfluencerDialog
             cancelBtnLabel="{{'discover.influencer.keep_selection' | translate:{container : 'group'} }}"
             acceptBtnLabel="{{'discover.influencer.clear_selection' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="clearPreviewedInfluencerOrPost()"
             (cancelCallback)="closeWarningClearSelectedInfluencerPopup()">
  <div class="d-flex flex-column flex-auto">
    <span>{{messageWhenClearPreviewedItem}}</span>
  </div>
</achoo-popup>
<achoo-popup #NotificationAfterAddPostToProject
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (acceptCallback)="closeNotificationAddPostToProject()"
             (cancelCallback)="closeNotificationAddPostToProject()">
  <span>{{'discover.notification_after_add_post_to_project' | translate:{projectName: projectName} }}</span>
</achoo-popup>
<achoo-popup #AlertAddPostToCampaignSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <div class="d-flex flex-column flex-auto" *ngIf="selectedCampaign">
    <span>
      {{'discover.msg_add_post_to_campaign_successful' | translate:{campaignName: selectedCampaign.campaign_name} }}
    </span>
  </div>
</achoo-popup>
<achoo-popup #AddInfluencerToCampaignErrorPopup
             [isNotification]="false"
             modelTitle="{{'common.alert' | translate}}"
             [acceptBtnLabel]="'common.btn.ok_thanks' | translate"
             [cancelBtnLabel]="'common.btn.contact_support' | translate"
             (acceptCallback)="closeConfirmationPopup()"
             (cancelCallback)="contactSupport()"
             (closeCallback)="closeConfirmationPopup()">
  <span>{{'discover.add_influencer_to_campaign_error_message' | translate}}</span>
</achoo-popup>
<achoo-popup #AddInfluencerToGroupErrorPopup
             [modelTitle]="'common.alert' | translate"
             acceptBtnLabel="{{'common.btn.ok_close' | translate}}"
             [isAlertPopup]="true"
             (closeCallback)="closeErrorAddingInfluencerAlert()"
             (acceptCallback)="closeErrorAddingInfluencerAlert()">
  <div class="d-flex flex-column flex-auto">
    <span [innerHTML]="'group_details.influencer.add_infl_error_message' | translate"></span>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bottombar-influencer-fragement.component.html